import { defineMessages } from "react-intl";

export const extraSaveWarningsMessages = defineMessages({
  title: {
    id: "extrasCategories.extraForm.saveWarningsTitle",
    defaultMessage: "Extra saved",
  },
  agrCategoryNotEnabled: {
    id: "extrasCategories.extraForm.agrCategoryNotEnabled",
    defaultMessage:
      "The category has been propagated to {total, plural, one {# property} other {# properties}}; it is not enabled in {disabled} and will not apply until it is:",
  },
});
